import React from "react";

/**
 * Celda de nombre de producto: botón que abre la ficha, con el nombre truncado
 * en UNA línea y «…» al final.
 *
 * Los nombres de CIMA son ~80% relleno («COMPRIMIDOS RECUBIERTOS CON PELICULA,
 * 28 comprimidos») y ponen la señal delante (marca + dosis), así que cortar por
 * la derecha conserva lo útil. El nombre completo queda en el `title` (tooltip)
 * y en la ficha del producto.
 *
 * Requiere `tableLayout: "fixed"` en la tabla: sin ancho de columna acotado, el
 * `text-overflow` no tiene contra qué recortar y la celda crece hasta caber.
 */
const truncate: React.CSSProperties = {
  // minWidth:0 es lo que permite al flex item encogerse por debajo de su
  // contenido; sin él, `text-overflow` nunca llega a actuar.
  flex: 1, minWidth: 0,
  whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
  lineHeight: 1.3,
};

export default function ProductNameCell({
  name, onClick, icon, title, children, color = "var(--clr-org-primary)", fontWeight = 600,
}: {
  name: string | null;
  onClick?: () => void;         // sin onClick → texto plano (competidor sin CN)
  icon: React.ReactNode;
  title?: string;
  children?: React.ReactNode;   // chips u otro contenido bajo el botón
  color?: string;
  fontWeight?: number;
}) {
  if (!name || !onClick) {
    return (
      <td style={{ padding: "0.6rem 10px", maxWidth: 0 }}>
        <div style={{ ...truncate, color: "var(--clr-text3)" }} title={name || undefined}>{name || "–"}</div>
        {children}
      </td>
    );
  }
  return (
    <td style={{ padding: "4px 8px", maxWidth: 0 }}>
      <button
        onClick={onClick}
        title={title ?? name}
        style={{
          display: "flex", alignItems: "center", gap: 6, width: "100%",
          background: "transparent", border: "1px solid transparent", borderRadius: 8,
          padding: "4px 8px", cursor: "pointer",
          color, fontSize: "inherit",
          textAlign: "left", fontFamily: "inherit", fontWeight,
          transition: "background 0.15s ease, border-color 0.15s ease",
        }}
        onMouseEnter={e => { e.currentTarget.style.background = "var(--clr-hover)"; e.currentTarget.style.borderColor = "var(--clr-border)"; }}
        onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.borderColor = "transparent"; }}
      >
        <span style={truncate}>{name}</span>
        <span style={{ color: "var(--clr-text4)", display: "flex", flexShrink: 0 }}>{icon}</span>
      </button>
      {children}
    </td>
  );
}
